import { AnyAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { LocationModel } from '@app/interfaces/location';
import { getStoreApi } from '@app/api/store.api';
import { showError } from '@app/utils/message';
import { getLocationsApi } from '@app/api/location.api';

export interface LocationState {
  data: LocationModel[];
  loading: boolean;
  error: string | null;
}

const initialState: LocationState = {
  data: [],
  loading: false,
  error: null,
};

// Thunks
export const getLocations = createAsyncThunk<LocationModel[]>(
  'location/getLocations',
  async (_, { rejectWithValue }) => {
    try {
      const stores = await getLocationsApi()
      return stores || [];

    } catch (error) {
      return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
    }
  },
);

const isRejectedAction = (action: AnyAction) => {
  return action.type.endsWith('rejected');
};

// Slice
export const locationSlice = createSlice({
  name: 'location',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getLocations.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getLocations.fulfilled, (state, action) => {
        state.data = action.payload
        state.loading = false;
      })
      .addMatcher(isRejectedAction, (state, action) => {
        state.loading = false;
        showError(action.payload?.message || action.payload?.error || action?.error?.message);
      });
    }
  }
);

export default locationSlice.reducer;